<app-menu>
  <div class="archive-shell" [attr.data-theme]="themeMode">
    <div class="archive-wrapper mx-auto flex min-h-0 max-w-[1900px] flex-col gap-3 px-4 py-3">
      <header class="archive-toolbar">
        <div class="archive-title-stack min-w-0">
          <div class="archive-eyebrow">Operations / Archived Documents</div>
          <div class="flex min-w-0 flex-wrap items-center gap-3">
            <h1 class="truncate">Document Archive</h1>
            <span class="archive-readiness-pill" [ngClass]="resultToneClass">
              <i class="fa-solid" [ngClass]="resultIconClass"></i>
              {{ resultLabel }}
            </span>
          </div>
          <div class="archive-meta-strip">
            <span><strong>{{ ladingCount }}</strong> ladings</span>
            <span><strong>{{ documentCount }}</strong> documents</span>
            <span><strong>{{ formatBytes(totalBytes) || '0 B' }}</strong> bytes</span>
            <span><strong>{{ imagesOnly ? 'Images' : 'All' }}</strong> mode</span>
          </div>
        </div>

        <div class="archive-toolbar-actions">
          <button type="button" class="archive-button archive-button--ghost" (click)="toggleTheme()" [title]="getThemeLabel() + ' theme'">
            <i [class]="getThemeIcon()"></i>
            <span>{{ getThemeLabel() }}</span>
          </button>
          <button type="button" class="archive-button archive-button--ghost" (click)="clearSearch()" [disabled]="isLoading && !query">
            <i class="fa-solid fa-xmark"></i>
            <span>Clear</span>
          </button>
          <button type="button" class="archive-button archive-button--primary" (click)="search()" [disabled]="isLoading || !query.trim()">
            <i class="fa-solid fa-magnifying-glass" [class.fa-beat-fade]="isLoading"></i>
            <span>{{ isLoading ? 'Searching' : 'Search' }}</span>
          </button>
        </div>
      </header>

      <div class="archive-alert archive-alert--error" *ngIf="errorMessage">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <main class="archive-work-grid min-h-0">
        <aside class="archive-panel archive-search-panel min-h-0">
          <div class="archive-panel-header">
            <div>
              <div class="archive-eyebrow">Lookup</div>
              <h2>Archive Search</h2>
            </div>
            <span class="archive-mini-status" [ngClass]="resultToneClass">{{ queryLabel }}</span>
          </div>

          <form class="archive-search-body" (ngSubmit)="search()">
            <div class="archive-file-mode-toggle">
              <button type="button" [class.is-active]="queryType === 'alternate_reference'" (click)="setQueryType('alternate_reference')">
                <i class="fa-solid fa-hashtag"></i>
                <span>Alt Ref</span>
              </button>
              <button type="button" [class.is-active]="queryType === 'lading_uuid'" (click)="setQueryType('lading_uuid')">
                <i class="fa-solid fa-fingerprint"></i>
                <span>Lading</span>
              </button>
            </div>

            <label class="archive-field">
              <span>{{ queryLabel }}</span>
              <input
                name="archiveQuery"
                [(ngModel)]="query"
                [placeholder]="queryPlaceholder"
                autocomplete="off"
              >
            </label>

            <label class="archive-check-label">
              <input type="checkbox" class="archive-check" name="imagesOnly" [(ngModel)]="imagesOnly">
              <span>Images only</span>
            </label>

            <div class="archive-side-actions">
              <button type="submit" class="archive-button archive-button--primary" [disabled]="isLoading || !query.trim()">
                <i class="fa-solid fa-magnifying-glass" [class.fa-beat-fade]="isLoading"></i>
                <span>{{ isLoading ? 'Searching' : 'Search' }}</span>
              </button>
              <button type="button" class="archive-button archive-button--ghost" (click)="clearSearch()">
                <i class="fa-solid fa-eraser"></i>
                <span>Reset</span>
              </button>
            </div>
          </form>

          <section class="archive-readiness-card" [ngClass]="resultToneClass">
            <div class="archive-readiness-head">
              <div>
                <span>Snapshot</span>
                <strong>{{ resultLabel }}</strong>
              </div>
              <b>{{ documentCount }}</b>
            </div>
            <div class="archive-progress">
              <span [style.width.%]="result ? 100 : 0"></span>
            </div>
            <div class="archive-readiness-grid">
              <span><strong>{{ ladingCount }}</strong> ladings</span>
              <span><strong>{{ documentCount }}</strong> docs</span>
              <span><strong>{{ formatBytes(totalBytes) || '0 B' }}</strong> total</span>
              <span><strong>{{ imagesOnly ? 'On' : 'Off' }}</strong> images</span>
            </div>
            <p>{{ result ? result.query : 'Waiting for a lookup.' }}</p>
          </section>
        </aside>

        <section class="archive-panel archive-workbench min-h-0">
          <div class="archive-results-head">
            <div class="min-w-0">
              <div class="archive-eyebrow">Results</div>
              <h2 class="truncate">Archived Documents</h2>
            </div>
            <span class="archive-result-context" *ngIf="result">
              {{ result.query_type === 'lading_uuid' ? 'Lading UUID' : 'Alternate Reference' }} / {{ result.query }}
            </span>
          </div>

          <div class="archive-workbench-body">
            <div class="archive-empty" *ngIf="!result && !isLoading">
              <i class="fa-solid fa-folder-open"></i>
              <span>Enter a reference to search the archive.</span>
            </div>

            <div class="archive-empty" *ngIf="isLoading">
              <i class="fa-solid fa-rotate fa-spin"></i>
              <span>Searching archived documents.</span>
            </div>

            <div class="archive-empty" *ngIf="result && !hasResults && !isLoading">
              <i class="fa-solid fa-folder-minus"></i>
              <span>No archived documents found.</span>
            </div>

            <div class="archive-lading-list" *ngIf="hasResults">
              <article class="archive-group-card" *ngFor="let lading of ladings; trackBy: trackByLadingUuid">
                <header class="archive-group-head">
                  <div class="min-w-0">
                    <div class="archive-eyebrow">Lading</div>
                    <h3 class="truncate">{{ lading.alternate_reference || lading.lading_uuid }}</h3>
                    <p>{{ lading.customer_name || 'No customer name' }}</p>
                  </div>
                  <span class="archive-status-pill archive-tone--ready">{{ lading.documents.length }} docs</span>
                </header>

                <div class="archive-group-facts">
                  <span><small>Lading UUID</small><strong>{{ lading.lading_uuid }}</strong></span>
                  <span><small>Created</small><strong>{{ formatDateText(lading.created) || 'n/a' }}</strong></span>
                  <span *ngIf="lading.lading_number"><small>Lading #</small><strong>{{ lading.lading_number }}</strong></span>
                  <span *ngIf="lading.pro_bill"><small>Pro Bill</small><strong>{{ lading.pro_bill }}</strong></span>
                  <span *ngIf="lading.trip_number"><small>Trip</small><strong>{{ lading.trip_number }}</strong></span>
                  <span *ngIf="lading.shipment_number"><small>Shipment</small><strong>{{ lading.shipment_number }}</strong></span>
                </div>

                <div class="archive-doc-table-wrap">
                  <table class="archive-doc-table">
                    <thead>
                      <tr>
                        <th>File</th>
                        <th>Format</th>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Size</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let document of lading.documents; trackBy: trackByDocumentId">
                        <td>
                          <strong>{{ document.file_name || 'Untitled' }}</strong>
                          <small>{{ document.source_table || document.document_uuid || '' }}</small>
                        </td>
                        <td><span class="archive-format-pill">{{ document.file_format || document.file_type || 'File' }}</span></td>
                        <td>{{ document.file_description || document.file_type || '' }}</td>
                        <td>{{ formatDateText(document.document_date) }}</td>
                        <td>{{ formatBytes(document.decoded_bytes) }}</td>
                        <td class="archive-action-cell">
                          <button
                            type="button"
                            class="archive-icon-button"
                            title="Open file"
                            aria-label="Open file"
                            [disabled]="openingDocumentId === document.id"
                            (click)="openDocument(document)"
                          >
                            <i class="fa-solid" [ngClass]="openingDocumentId === document.id ? 'fa-rotate fa-spin' : 'fa-up-right-from-square'"></i>
                          </button>
                        </td>
                      </tr>
                      <tr *ngIf="!lading.documents.length">
                        <td colspan="6" class="archive-no-docs">No documents</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </article>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</app-menu>
